import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EAddMachineStep } from 'core/enums/add-machine.enum';
import { TSetUserMachineValues } from 'core/models/machine/machine.model';

const defaultFormValues: TSetUserMachineValues = {
  userMachineId: 0,
  plateNumberFirstTwoDigits: '',
  plateNumberMiddleLetter: '',
  plateNumberLastFiveDigits: '',
  engineNumber: '',
  chassisNumber: '',
  serialNumberOrModel: '',
  locationOfServices: null,
  typeOfOwnership: null,
  typeOfMachineUse: null,
  machinery: null,
  thirdPartyInsurance: null,
  hallInsurance: null,
  thirdPartyInsuranceValidityDate: '',
  hallInsuranceValidityDate: '',
  hallInsuranceStatus: false,
  thirdPartyInsuranceStatus: false,
};

interface IUserMachineState {
  initialValues: TSetUserMachineValues;
  currentStep: EAddMachineStep;
  isModalOpen: boolean;
}

const initialState: IUserMachineState = {
  initialValues: defaultFormValues,
  currentStep: EAddMachineStep.OperationalInfo,
  isModalOpen: false,
};

const userMachineSlice = createSlice({
  name: 'userMachine',
  initialState,
  reducers: {
    setInitialValues: (state, action: PayloadAction<TSetUserMachineValues>) => {
      state.initialValues = action.payload;
    },
    resetInitialValues: (state) => {
      state.initialValues = defaultFormValues;
    },
    setCurrentStep: (state, action: PayloadAction<EAddMachineStep>) => {
      state.currentStep = action.payload;
    },
    openModal: (state) => {
      state.isModalOpen = true;
    },
    closeModal: (state) => {
      state.initialValues = defaultFormValues;
      state.currentStep = EAddMachineStep.OperationalInfo;
      state.isModalOpen = false;
    },
  },
});

export const {
  setInitialValues,
  resetInitialValues,
  setCurrentStep,
  openModal,
  closeModal,
} = userMachineSlice.actions;

export default userMachineSlice.reducer;
